export const messages = {
  en: {
    complaintDetail: {
      title: 'Complaint Details',
      orderId: 'Order ID',
      type: 'Type',
      room: 'Room',
      contact: 'Contact',
      phone: 'Phone',
      status: 'Status',
      createTime: 'Create Time',
      content: 'Content',
      workflow: 'Workflow',
      evaluation: 'Evaluation',
      fetchError: 'Failed to fetch complaint details'
    },
    complaintDetailEvent: {
      type: 'Type',
      operator: 'Operator',
      remark: 'Remark',
      time: 'Time',
      submit: 'Submit',
      process: 'Process',
      evaluate: 'Evaluate',
      reply: 'Reply',
      fetchError: 'Failed to fetch event list'
    },
    complaintDetailAppraise: {
      user: 'User Name',
      content: 'Evaluation Content',
      score: 'Evaluation Score',
      status: 'Evaluation Status',
      time: 'Evaluation Time',
      replier: 'Replier',
      replyContent: 'Reply Content',
      pending: 'Pending Reply',
      replied: 'Replied',
      fetchError: 'Failed to fetch evaluation list'
    },
        complaintDetailType: {
      name: 'Type Name',
      notifyWay: 'Notification Method',
      replyType: 'Reply Type',
      handler: 'Handler',
      createTime: 'Create Time',
      sms: 'SMS',
      wechat: 'WeChat',
      autoReply: 'Auto Reply',
      manualReply: 'Manual Reply',
      fetchError: 'Failed to fetch type list'
    }
  },
  zh: {
    complaintDetail: {
      title: '投诉详情',
      orderId: '订单编号',
      type: '类型',
      room: '房屋',
      contact: '联系人',
      phone: '联系电话',
      status: '状态',
      createTime: '创建时间',
      content: '投诉内容',
      workflow: '工单流转',
      evaluation: '工单评价',
      fetchError: '获取投诉详情失败'
    },
    complaintDetailEvent: {
      type: '类型',
      operator: '操作人',
      remark: '说明',
      time: '时间',
      submit: '提交',
      process: '投诉处理',
      evaluate: '评价',
      reply: '评价回复',
      fetchError: '获取事件列表失败'
    },
    complaintDetailAppraise: {
      user: '用户名称',
      content: '评价内容',
      score: '评价得分',
      status: '评价状态',
      time: '评价时间',
      replier: '回复人',
      replyContent: '回复内容',
      pending: '待回复',
      replied: '已回复',
fetchError: '获取评价列表失败'
    },
    complaintDetailType: {
      name: '类型名称',
      notifyWay: '通知方式',
      replyType: '评价回复',
      handler: '处理人',
      createTime: '创建时间',
      sms: '短信',
      wechat: '微信',
      autoReply: '自动回复',
      manualReply: '人工回复',
fetchError: '获取类型列表失败'
    }
  },
  'zh-TW': {
    complaintDetail: {
      title: '投訴詳情',
      orderId: '訂單編號',
      type: '類型',
      room: '房屋',
      contact: '聯繫人',
      phone: '聯繫電話',
      status: '狀態',
      createTime: '創建時間',
      content: '投訴內容',
      workflow: '工單流轉',
      evaluation: '工單評價',
      fetchError: '獲取投訴詳情失敗'
    },
    complaintDetailEvent: {
      type: '類型',
      operator: '操作人',
      remark: '說明',
      time: '時間',
      submit: '提交',
      process: '投訴處理',
      evaluate: '評價',
      reply: '評價回復',
      fetchError: '獲取事件列表失敗'
    },
    complaintDetailAppraise: {
      user: '用戶名稱',
      content: '評價內容',
      score: '評價得分',
      status: '評價狀態',
      time: '評價時間',
      replier: '回復人',
      replyContent: '回復內容',
      pending: '待回復',
      replied: '已回復',
      fetchError: '獲取評價列表失敗'
    },
    complaintDetailType: {
      name: '類型名稱',
      notifyWay: '通知方式',
      replyType: '評價回復',
      handler: '處理人',
      createTime: '創建時間',
      sms: '短信',
      wechat: '微信',
      autoReply: '自動回復',
      manualReply: '人工回復',
      fetchError: '獲取類型列表失敗'
    }
  }
}